export function processData(data) {
    const result = {};

    data.forEach((pair) => {
        const date = pair[0].split(' ')[0];
        const startTime = pair[0].split(' ')[1];

        if (!result[date]) {
            result[date] = {};
        }

        result[date][startTime] = 'available';
    });

    return result;
}

export function transformDoctorsData(input) {
    const result = [];

    for (const key in input) {
        result.push({
            id: parseInt(key),
            title: input[key],
        });
    }

    return result;
}
